import Modal from "react-bootstrap/Modal";
import "../style/rightside.css";
import { useState } from "react";
import checkbox from "../asset/images/Checkbox.svg";
import RecordPaymentTransactionForm from "./RecordPaymentTransactionForm";

function PaymentMethodComp(props) {
  const [selectedIndex, setSelectedIndex] = useState(-1);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [show, setShow] = useState(false);

  const closeModal = () => {
    props.setshow(false);
  };

  return (
      <>
          <RecordPaymentTransactionForm
              show={show}
              setshow={setShow}
              selectedinvoice={props.selectedinvoice}
              selectedmethods={selectedMethod}
              record={props.record}
              setinvoices={props.setinvoices}
              currency={props.currency}
              tenure={props.tenure}
              setSelectedMethod={setSelectedMethod}
          />
          <Modal
              show={props.show}
              className="addpaymentmodal"
              size="lg"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              onHide={() => props.setshow(false)}
          >
              <Modal.Body
                  style={{
                      borderRadius: "16px",
                      padding: "0px",
                      border: "none",
                  }}
              >
                  <div
                      style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "14px",
                      }}
                  >
                      <div
                          className=""
                          style={{
                              borderBottom: "1px solid #E7E9FB",
                              padding: "8px 24px 8px 24px",
                          }}
                      >
                          <span
                              className="material-icons"
                              style={{ color: "#667085" }}
                              onClick={closeModal}
                          >
                              close
                          </span>
                      </div>
                      <div style={{ padding: "8px 24px 8px 24px" }}>
                          <div
                              style={{
                                  display: "flex",
                                  flexDirection: "column",
                                  gap: "4px",
                              }}
                          >
                              <h3
                                  style={{
                                      fontWeight: "700",
                                      color: "#101828",
                                      lineHeight: "24.3px",
                                      fontSize: "18px",
                                  }}
                              >
                                  Choose payment type
                              </h3>
                              <div className="mb-3 border-0 card">
                                  <div className="p-1 card-body">
                                      {props.tenure.map((tenures, index) => (
                                          <div
                                              key={index}
                                              className={`flex justify-between items-center rounded-lg ${
                                                  selectedIndex === index ? "#F4F0FF" : ""
                                              }`}
                                              onClick={() => {
                                                  setSelectedIndex(index);
                                                  props.setselectedmethod(tenures);
                                                  setSelectedMethod(tenures);
                                                  setShow(true);
                                                  props.setshow(false);
                                              }}
                                          >
                                              <span
                                                  className="text-[#101828] font-medium text-base py-[6px] px-2"
                                              >
                                                  {tenures}
                                              </span>
                                              {selectedIndex === index && (
                                                  <img
                                                      src={checkbox}
                                                      alt="check icon"
                                                      className="size-[13.33px] mr-[10px]"
                                                  />
                                              )}{" "}
                                          </div>
                                      ))}{" "}
                                  </div>
                              </div>
                          </div>
                      </div>
                  </div>
              </Modal.Body>
          </Modal>
      </>
  );
}

export default PaymentMethodComp;
